var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('image'),style:({height:_vm.setPx(_vm.size)})},[_c('img',{attrs:{"src":_vm.emptyInfo.image,"alt":""}})]),_c('p',{class:_vm.b('desc')},[_vm._v(_vm._s(_vm.emptyInfo.desc))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }